export default __webpack_public_path__ + "static/media/icon_ms_sql.3dd62d47.svg";